import { Button, Menu, MenuItem, Position } from '@blueprintjs/core';
import { Popover2 } from '@blueprintjs/popover2';
import { IconNames } from '@blueprintjs/icons';
import { useNavigate } from 'react-router-dom';
import AppToaster from '../../../AppToaster';
import { EmployeeInfoFragment, useDeleteEmployeeMutation } from '../../../generated/graphql';
import { showErrorMessage } from '../../../helpers/graphql';

type EmployeeDetailMenuProps = {
  employee: EmployeeInfoFragment;
  onEdit: () => void;
};

const EmployeeDetailMenu = ({ employee, onEdit }: EmployeeDetailMenuProps) => {
  const navigate = useNavigate();
  const [deleteEmployee, { loading: deleting }] = useDeleteEmployeeMutation({
    variables: {
      id: employee.id,
    },
    onError: showErrorMessage,
    onCompleted: () => {
      AppToaster.success(`${employee.display_name}  wurde in den Papierkorb gelegt`);
      navigate(-1);
    },
  });

  return (
    <>
      <Button text="Bearbeiten" icon={IconNames.EDIT} className="ml-2" onClick={onEdit} />
      <Popover2
        position={Position.BOTTOM}
        content={
          <Menu>
            <MenuItem text="In den Papierkorb" icon={IconNames.TRASH} onClick={deleteEmployee as any} />
          </Menu>
        }
      >
        <Button icon={IconNames.MORE} className="ml-2" loading={deleting} />
      </Popover2>
    </>
  );
};

export default EmployeeDetailMenu;
